import Footer from "../../components/Footer";
import PHD_1 from "../../assets/img/phd_1.png";
import PHD_2 from "../../assets/img/phd_2.png";
import PG_1 from "../../assets/img/pg_1.png";
import PG_2 from "../../assets/img/pg_2.png";
import PG_3 from "../../assets/img/pg_3.png";
import "../style.css";
import { useParams } from "react-router-dom";
import PageWiseLearnMore from "./PageWiseLearnMore";
import LearnMoreSection from "./LearnMoreSection";
import Group from "./Group";
export default function PHDApplicationMentorship() {
  const { id } = useParams();
  const learnMoreDataCourseFinder = {
    topHeaderSection: {
      header: "PhD Application Service",
      desc: "Writing a strong proposal and submitting it to the right supervisor is crucial in determining whether your application is successful, and our expert team will guide you step by step throughout.",
      img: PHD_1,
    },
    headerSec: {
      header: "Your Complete Partner in Global Education",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
    },
    secondSection: {
      img: PG_2,
      header: "Expert guidance for your PhD application",
      desc: "A PhD (Doctor of Philosophy) is one of the highest academic qualifications awarded by universities, requiring you to complete a thesis on a substantial piece of research judged by a panel of experts. The application process for international students pursuing a PhD in the Global can be highly competitive and requires careful planning, strong supporting documents, and a compelling research proposal. Global StudyIn’s PhD Application Service helps you navigate this process with expert guidance on choosing the right university, refining your research proposal, and preparing for interviews so you have the best chances of gaining admission to your preferred programme.",
    },
    thirdSection: {
      rightSection: {
        img: PHD_2,
      },
      leftSection: {
        header: "What is included?",
        desc: "The PhD Application Service provides personalised support to ensure you have a strong and competitive submission for your preferred PhD programme.",
      },
      leftColumnContent: [
        {
          title: "University selection guidance",
          description:
            "We will evaluate your study goals and provide personalised guidance on your course options",
        },
        {
          title: "Eligibility assessment",
          description:
            "We will pre-screen your academic transcripts and qualifications to confirm your eligibility to your preferred university and course",
        },
        {
          title: "Application management",
          description:
            "Receive review your academic transcripts, CV, and reference letters, sharing suggestions for improvement assistance with completing and reviewing your university application forms to ensure they’re accurate",
        },
        {
          title: "Research proposal review",
          description:
            "Our experts will review and provide constructive feedback on editing your research proposal to ensure it matches the standards of your programme",
        },
        {
          title: "Application tracking",
          description:
            "We will track the progress of your applications after submission, closely monitoring their progress and keeping you informed",
        },
        {
          title: "Documentation support",
          description:
            "Understand what academic transcripts, reference letters, and other documents you need to submit with your application and how to align your personal statement, CV, and reference letters with university expectations",
        },
        {
          title: "Interview preparation",
          description:
            "Participate in a 60-minute non-subject-specific interview session and receive a feedback report on what and where to improve",
        },
      ],
      rightColumnContent: [
        {
          title: "Scholarship advice",
          description:
            "Learn about available scholarships and funding opportunities to help finance your studies in the Global.",
        },
        {
          title: "University offer selection",
          description:
            "Get expert guidance on evaluating and selecting the best university offer based on your goals.",
        },
        {
          title: "Ongoing application support",
          description:
            "Receive support throughout the entire application process, from submission to enrolment.",
        },
      ],
    },
    fourthSection: {
      header: "Start your Education Journey Today",
      desc: "Ready to take the next step? Book a free consultation with our education experts and let us help you achieve your Global study goals.",
    },
  };

  const learnMoreDataServices = {
    topHeaderSection: {
      header: "Free expert support tailored to your study goals",
      desc: "Our complimentary application assistance is designed to guide you at every step and improve your chances of securing admission to a Global university or college.",
      img: PG_1,
    },
    headerSec: {
      header: "Your Complete Partner in Global Education",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
    },
    secondSection: {
      img: PG_2,
      header: "Get expert advice for your Global university application",
      desc: "Applying to universities and colleges in the Global requires careful planning and a clear understanding of entry requirements, deadlines, and necessary documents. With highly competitive admissions, a strong application is essential to secure your place at your preferred institution.Global StudyIn’s free university application service provides expert guidance at every stage – from course selection and eligibility checks to personal statement refinement and document preparation. With support from our specialist counsellors, you’ll gain the tools and confidence to submit an outstanding application.",
    },
    thirdSection: {
      rightSection: {
        img: PG_3,
      },
      leftSection: {
        header: "What is included?",
        desc: " With a 98% success rate, our Free Support service is designed to make your university application process as straightforward as possible. Here's what we offer:",
      },
      leftColumnContent: [
        {
          title: "Free 40-minute consultation",
          description:
            "Meet with a university consultant in our office or online to discuss your study options in the Global.",
        },
        {
          title: "University recommendations",
          description:
            "Receive a list of recommended universities for you to apply to based on your academic requirements and preferences.",
        },
        {
          title: "Application support",
          description:
            "Get assistance with completing and reviewing your university application forms to ensure they’re accurate.",
        },
        {
          title: "Personal statement review",
          description:
            "Refine your personal statement with expert guidance to showcase your strengths and motivations.",
        },
        {
          title: "Documentation support",
          description:
            "Understand what academic transcripts, reference letters, and other documents you need for your application.",
        },
      ],
      rightColumnContent: [
        {
          title: "Scholarship advice",
          description:
            "Learn about available scholarships and funding opportunities to help finance your studies in the Global.",
        },
        {
          title: "University offer selection",
          description:
            "Get expert guidance on evaluating and selecting the best university offer based on your goals.",
        },
        {
          title: "Ongoing application support",
          description:
            "Receive support throughout the entire application process, from submission to enrolment.",
        },
      ],
    },
    fourthSection: {
      header: "Start your Education Journey Today",
      desc: "Ready to take the next step? Book a free consultation with our education experts and let us help you achieve your Global study goals.",
    },
    enablePaymentRedirection: true
  };
  const data = id == 1 ? learnMoreDataCourseFinder : learnMoreDataServices;

  return (
    <div className="personalised-guidance phd-application">
      <PageWiseLearnMore activePageId={id} learnMoreData={data} />
      <Group />
      <LearnMoreSection learnMoreData={data} />

      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );
}
